import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { persistReducer, persistStore } from 'redux-persist';
import sessionStorage from 'redux-persist/es/storage/session';

import { authApi } from 'services/authApi';
import { apiKeyApi } from 'services/apiKeyApi';
import { userApi } from 'services/userApi';
import { promptApi } from 'services/promptApi';
import { roleApi } from 'services/roleApi';
import { applicationApi } from 'services/applicationApi';
import { anonymizeApi } from 'services/anonymizeApi';
import { assistantApi } from 'services/assistantApi';
import { knowledgeBaseApi } from 'services/knowledgeBaseApi';
import { ragApi } from 'services/ragApi';

import authSlice from 'slice/authSlice';
import appReducer from 'slice/appSlice';

const authPersistConfig = {
  key: 'auth',
  storage: sessionStorage
};

const reducers = combineReducers({
  auth: persistReducer(authPersistConfig, authSlice.reducer),
  // Add the generated reducer as a specific top-level slice
  [authApi.reducerPath]: authApi.reducer,
  [applicationApi.reducerPath]: applicationApi.reducer,
  [apiKeyApi.reducerPath]: apiKeyApi.reducer,
  [userApi.reducerPath]: userApi.reducer,
  [promptApi.reducerPath]: promptApi.reducer,
  [roleApi.reducerPath]: roleApi.reducer,
  [anonymizeApi.reducerPath]: anonymizeApi.reducer,
  [assistantApi.reducerPath]: assistantApi.reducer,
  [knowledgeBaseApi.reducerPath]: knowledgeBaseApi.reducer,
  [ragApi.reducerPath]: ragApi.reducer,
  app: appReducer
});

const store = configureStore({
  reducer: reducers,
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({ serializableCheck: false }),
    authApi.middleware,
    applicationApi.middleware,
    apiKeyApi.middleware,
    userApi.middleware,
    promptApi.middleware,
    roleApi.middleware,
    anonymizeApi.middleware,
    assistantApi.middleware,
    knowledgeBaseApi.middleware,
    ragApi.middleware
  ],
  devTools: true
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);

export default store;
export const persistor = persistStore(store);
